import React, { useMemo } from 'react'
import { TargetingType } from '../../config'
import { resolveValueAndMessage } from './StateBadge'
import { BadgeSmall, resolveStateMessage } from './SmallBadge'
import { ClassValue } from 'classnames'

interface TargetingTypeSmallProps {
    targeting_type: number
    state?: number
    parent_ad_group_status?: number
    parent_campaign_status?: number
    className?: ClassValue
}

export const TargetingTypeSmall = ({
    targeting_type,
    state = 0,
    parent_ad_group_status,
    parent_campaign_status,
    className,
}: TargetingTypeSmallProps) => {
    const {
        letter,
        classes,
        message: typeMessage,
    } = useMemo(() => {
        switch (targeting_type) {
            case TargetingType.Manual:
                return {
                    letter: 'M',
                    classes: 'targeting-type-badge-manual',
                    message: 'Manual targeting',
                }
            case TargetingType.Auto:
                return {
                    letter: 'A',
                    classes: 'targeting-type-badge-auto',
                    message: 'Auto targeting',
                }
            default:
                console.warn('Unknown targeting type', targeting_type)
                return {}
        }
    }, [targeting_type])

    const { value, stateMessage } = useMemo(() => {
        const raw = resolveValueAndMessage(state, parent_ad_group_status, parent_campaign_status)
        const { value, message: stateMessage } = resolveStateMessage(raw)

        return {
            value,
            stateMessage,
        }
    }, [state, parent_ad_group_status, parent_campaign_status])

    const message = useMemo(() => {
        return (
            <div>
                <div>{typeMessage}</div>
                <div>{stateMessage}</div>
            </div>
        )
    }, [typeMessage, stateMessage])

    return (
        <BadgeSmall
            className={className}
            letter={letter}
            classes={classes}
            state={value}
            message={message}
        />
    )
}
